import React from 'react';
import '../App.css';
import '../css/RiskAssessment.css';
import CHOPHeader from './CHOPHeader';
import PicuHeader from './PicuHeader';
import { NavLink, useLocation } from 'react-router-dom';
import WriteToLog from '../services/WriteToLog';

function Error() {
  const title = "Error";
  const note = "";
  const unitLink = <NavLink to='/units' className='list-link'>Units</NavLink>;
  const location = useLocation();
  const { selectedPatient, failure } = location.state;
  WriteToLog("ABC Error Page for patient: " + JSON.stringify(selectedPatient));
  WriteToLog("ABC Error message: " + failure);
  
  const banner = selectedPatient.need_patient_banner;
  const room = selectedPatient.ROOM_BED;
  const name = selectedPatient.PATIENT_LAST_NAME + ', ' + selectedPatient.PATIENT_FIRST_NAME;
  const mrn = selectedPatient.MRN;
  const age = selectedPatient.AGE;
  const weight = selectedPatient.DOSING_WEIGHT;

  const link = '/patients/' + selectedPatient.UNIT_LIST_ID + "/" + selectedPatient.NURSING_UNIT;
  const patientLink = <NavLink to={link} className='list-link'>Patients</NavLink>;

  return (
    <div className='RiskAssessment'>
      <CHOPHeader unitLink={unitLink} patientLink={patientLink} />
      <PicuHeader banner={banner} room={room} name={name} mrn={mrn} age={age} weight={weight} title={title} note={note}/>

      <div className='left-space'>
        <h3 className="red-font">Something went wrong!</h3>
        <p>An error occurred in the application when {failure}.</p>
      </div>    
    </div>
  )
}

export default Error;
